export default class IFrameService {

	static parentData = () => {
		window.parent.postMessage({
			height: document.getElementById('root').offsetHeight,
			path: document.location.pathname
		},"*");
	}
}




// WEBPACK FOOTER //
// ./src/service/IFrameService.js